import Card from 'react-bootstrap/Card';
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function CardBody(school) {

    const styles = {
        //backgroundImage: `linear-gradient(rgba(128, 128, 128, 0.2), rgba(128, 128, 128, 0.2)), url(${school.image})`,
    
        backgroundSize: 'cover',
        backgroundPosition: 'center',

        color: 'white',
        textAlign: 'center',
        marginLeft: '10px',
        marginRight: '10px',
        marginTop: '10px',
        height: 'fit-content',
        
    };
    
    const buttonStyle = {
        color: 'rgba(40, 79, 170, 1)',
        textAlign: 'center',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight:'900'

    }
    
    const textStyle = {
        //textShadow: '1px 1px 1px rgba(0, 0, 0, 0.7)',

        
    };

   
    
    return (
        <Col md={4} sm={6}>
            <Card style={styles}>
                <Card.Body className='card-body d-flex flex-column'>
                    <Card.Img variant="top"src={school.image} style={{objectFit: 'contain',objectPosition: 'top center', height: '200px', itbackgroundColor: 'white',padding: '1rem',}}/>
                    {/* <Card.Title style={{...textStyle, fontWeight: '800'}} className="justify-content-center d-flex"><Trans ns="sateliteSchools" i18nKey={school.name} /></Card.Title> */}
                    <Card.Text className='card-text mt-auto mb-3' style={{...textStyle, ...buttonStyle}}>
                        <Trans ns="sateliteSchools" i18nKey={`${school.name} preview`} />
                    </Card.Text>
                    <Button as={Link} to={`/school/${school.name}`} variant="primary" size="lg" className="btn-sm btn-color-yellow w-50 w-sm-25 mx-auto d-block mb-2 "><Trans i18nKey={"FindOutMoreAboutSchool"} /></Button>
                </Card.Body>
                
            </Card>
        </Col>
    );
}

function MainBlock() {
    const { t } = useTranslation('sateliteSchools');
    const schoolsList = useSelector(state => state.satelliteSchools.schools_list);
    const academySchool = schoolsList.find((item) => item.name === 'academy');
    const locationSchools = schoolsList.filter((item) => item.name !== 'academy');

    return (
        <>
            <div className="satellite-schools-highlight-band">
                <Row className="mb-1">
                    <Col xs={12} className="text-center satellite-schools-intro-wrap">
                        <div
                            className="satellite-schools-intro"
                            dangerouslySetInnerHTML={{ __html: t('academy overview intro') }}
                        />
                    </Col>
                </Row>
                <Row className="mb-2">
                    <Col xs={12} className="text-center satellite-schools-option-label satellite-schools-online-label">
                        <Trans ns="sateliteSchools" i18nKey="academy online option" />
                    </Col>
                </Row>
            </div>
            {academySchool && (
                <Row className="academy-feature-row justify-content-center">
                    <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
                        <Card className="academy-feature-card border-0 overflow-hidden shadow-sm w-100">
                            <div className="academy-feature-logo-wrap d-flex align-items-center justify-content-center">
                                <Card.Img
                                    variant="top"
                                    src={academySchool.image}
                                    className="academy-feature-logo"
                                    alt="St Mary’s Online Academy"
                                />
                            </div>
                            <Card.Body className="academy-feature-body d-flex flex-column">
                                <Card.Title className="academy-feature-title mb-3">
                                    <Trans ns="sateliteSchools" i18nKey={academySchool.name} />
                                </Card.Title>
                                <Card.Text className="academy-feature-text mb-4">
                                    <Trans ns="sateliteSchools" i18nKey={`${academySchool.name} preview`} />
                                </Card.Text>
                                <div className="mt-auto">
                                    <Button
                                        as={Link}
                                        to={`/school/${academySchool.name}`}
                                        variant="primary"
                                        size="lg"
                                        className="btn-sm btn-color-yellow academy-feature-button"
                                    >
                                        <Trans i18nKey={"FindOutMoreAboutSchool"} />
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            )}
            <div className="satellite-schools-highlight-band satellite-schools-inperson-band">
                <Row className="mb-2">
                    <Col xs={12} className="text-center satellite-schools-option-label satellite-schools-inperson-label">
                        <Trans ns="sateliteSchools" i18nKey="in-person study options" />
                    </Col>
                </Row>
            </div>
            <Row className='SateliteSchoolsLayoutBlock'>
                {locationSchools.map((item) => CardBody(item))}
            </Row>
        </>
    )
}

export default (MainBlock);

